<template>
  <div>
    <b-form-select :options="optionsUniquePendencyOpned" v-model="modelComp">
    </b-form-select>
    <!-- {{model}} -->
  </div>
</template>

<script>
export default {
  name: "PendencyUniqueOpenedDropdown",
  components: {},
  props: {
    model: {
      type: Boolean,
      default: false,
    },
    showZero: {
      type: Boolean,
      default: false,
    },
  },
  data: function () {
    return {};
  },
  computed: {
    modelComp: {
      get: function () {
        return this.model;
      },
      set: function (value) {
        this.$emit("update:model", value);
      },
    },
    optionsUniquePendencyOpned() {
      if (this.showZero) {
        return [
          { value: null, text: "" },
          { value: true, text: "Sim" },
          { value: false, text: "Não" },
        ];
      }
      return [
        { value: true, text: "Sim" },
        { value: false, text: "Não" },
      ];
    },
  },
  methods: {},
};
</script>
